var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512px",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    width: "512px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_x36_2-instagram"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_1_",
    x1: 65.9038,
    x2: 446.3573,
    y1: 444.4766,
    y2: 64.0231
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC107"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2211,
    style: {
      stopColor: "#F98D1C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5137,
    style: {
      stopColor: "#F1423B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8329,
    style: {
      stopColor: "#B93088"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#9C27B0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M343.193,22H168.32C87.854,22,23,86.863,23,166.958v174.079    C23,421.137,87.854,487,168.32,487h174.873C423.66,487,490,421.137,490,341.037V166.958C490,86.863,423.66,22,343.193,22z     M446,341.037C446,397.025,399.438,443,343.193,443H168.32C112.071,443,66,397.025,66,341.037V166.958    C66,110.973,112.071,65,168.32,65h174.873C399.438,65,446,110.973,446,166.958V341.037z",
    style: {
      fill: "url(#SVGID_1_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_2_",
    x1: 173.5107,
    x2: 338.0032,
    y1: 336.2451,
    y2: 171.7527
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC107"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2211,
    style: {
      stopColor: "#F98D1C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5137,
    style: {
      stopColor: "#F1423B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8329,
    style: {
      stopColor: "#B93088"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#9C27B0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M255.756,137.947c-64.382,0-116.581,51.961-116.581,116.055    c0,64.085,52.199,116.045,116.581,116.045c64.383,0,116.58-51.96,116.58-116.045C372.336,189.908,320.139,137.947,255.756,137.947    z M255.756,326.531c-40.164,0-72.86-32.551-72.86-72.529c0-40.016,32.696-72.534,72.86-72.534    c40.162,0,72.861,32.519,72.861,72.534C328.617,293.98,295.918,326.531,255.756,326.531z",
    style: {
      fill: "url(#SVGID_2_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    id: "SVGID_3_",
    x1: 370.1182,
    x2: 392.037,
    y1: 140.2031,
    y2: 118.2843
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC107"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2211,
    style: {
      stopColor: "#F98D1C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5137,
    style: {
      stopColor: "#F1423B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8329,
    style: {
      stopColor: "#B93088"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#9C27B0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M381.08,113.779c-8.581,0-15.538,6.924-15.538,15.463c0,8.54,6.957,15.467,15.538,15.467    c8.573,0,15.532-6.927,15.532-15.467C396.612,120.703,389.653,113.779,381.08,113.779z",
    style: {
      fill: "url(#SVGID_3_)"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagramIcon.c341bca2ba64af7ab997ab4f084f157a.svg";
export { ForwardRef as ReactComponent };